import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { z } from 'zod';
import { createAuthMutation } from '../auth-http-client';

export const createDeleteDeviceDetailedMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/device/details/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(z.null()),
		},
	});
